<div [ngClass]="{'general-loading': _loading.isLoading }" *blockUI="'componentsPrivateLayout'; message: null">
	<app-header-nav *ngIf="!isPortalClienteRoute"></app-header-nav>
	<router-outlet></router-outlet>
</div>
